// DS: i6.19
import React from 'react';
import IconWrap from '../../IconWrap';
const AddCoverImage = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "nonzero",
        d: "M3 21a1 1 0 01-1-1V6a1 1 0 011-1h10a1 1 0 010 2H4v9.271l1.879-1.878a1 1 0 011.32-.083l.094.083 1.619 1.62L6.084 19h2.754l5.862-6.192a1 1 0 011.413-.039l.038.038L18 14.973V12a1 1 0 012 0v8a1 1 0 01-1 1H3zm7.5-12a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19 3a1 1 0 011 1l-.001 1H21a1 1 0 010 2h-1.001L20 8a1 1 0 01-2 0l-.001-1H17a1 1 0 010-2h.999L18 4a1 1 0 011-1z"
    }))));
};
AddCoverImage.displayName = 'AddCoverImage';
export default AddCoverImage;

//# sourceMappingURL=AddCoverImage.js.map